import {Nullable} from '../../../app/TypeHelpers'
import moment, {Moment} from 'moment'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {judgeAuthorityCheck} from '../../../__NoAutomatedTests/common/util/Natutil'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {AVAILABLE_OR_NOT} from '../../../CodeMaster'
import {Id} from '../components/ReservationTimelineView'
import {numberOrNull} from '../../../stringHelper/stringHelpers'

export const convertToNullableMoment = (date: Nullable<string>, time: Nullable<string>): Nullable<moment.Moment> => {
    if (date === null) {
        return null
    }
    return convertToMoment(date, time)
}

export const convertToMomentOrError = (date: Nullable<string>, time: Nullable<string>): Moment => {
    if (date === null) {
        throw new Error('date cannot be null')
    }
    if (time === null) {
        throw new Error('date cannot be null')
    }
    return convertToMoment(date, time)
}

export const convertToMoment = (date: string, time: Nullable<string>): moment.Moment => {
    if (time === null) {
        return moment(`${date}`, 'YYYY-MM-DD')
    }
    return moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss')
}

export const calculateDurations = (
    startMoment: moment.Moment, endMoment: moment.Moment,
): { durationInMinute: number, durationInHour: number } => {
    const durationInMillisecond = endMoment.diff(startMoment)
    const durationInMinute: number = Math.ceil(durationInMillisecond / 1000 / 60)
    const durationInHour: number = Math.ceil(durationInMillisecond / 1000 / 60 / 60)
    return {
        durationInHour: durationInHour,
        durationInMinute: durationInMinute,
    }
}

export const durationString = (
    startMoment: moment.Moment, endMoment: moment.Moment,
): string => {
    if (!endMoment.isAfter(startMoment)) {
        return COMMON_CONSTANTS.INVALID_CALCULATE_RESULT
    }

    const {durationInMinute} = calculateDurations(startMoment, endMoment)

    const actualHour: number = Math.floor(durationInMinute / 60)
    const actualMinute: number = durationInMinute % 60

    const hourString: string = (actualHour > 0) ? `${actualHour}時間` : ''
    const minuteString: string = (actualMinute > 0) ? `${actualMinute}分` : ''

    return `${hourString}${minuteString}`
}

export const judgeFacilityReserveEditAuthority = (): boolean => {
    const viewMode: boolean = judgeAuthorityCheck('VIEW-FACILITY_RESERVE')
    const editMode: boolean = judgeAuthorityCheck('EDIT-FACILITY_RESERVE')

    const facilityReserveAvailability: string = SessionStorageHelper.getStringItemWithDefault(
        'facilityReserveAvailability', AVAILABLE_OR_NOT.UNAVAILABLE.value)

    if (!viewMode) {
        throw new Error('No View Authority')
    }
    if (!editMode) {
        return false
    }

    return AVAILABLE_OR_NOT.AVAILABLE.value === facilityReserveAvailability

}

export const convertToFacilityId = (id: Id): number => {
    const facilityId = numberOrNull(id ? id.toString() : null)
    if (!facilityId) {
        throw new Error(`cannot convert to facilityId -> ${id}`)
    }
    return facilityId
}

export const isCancelLimitOver = (
    startDateTimeMoment: Moment,
    currentDateTime: Moment,
    cancelAvailability: AVAILABLE_OR_NOT,
    cancelReceptionLimitDate: Nullable<number>,
    cancelReceptionLimitTime: Nullable<string>,
): boolean => {
    if (AVAILABLE_OR_NOT.AVAILABLE.value === cancelAvailability.value) {
        if (cancelReceptionLimitDate !== null) {
            const targetMoment: Moment =
                startDateTimeMoment.clone().subtract(cancelReceptionLimitDate - 1, 'days')

            if (currentDateTime.isSameOrAfter(targetMoment, 'day')) {
                return true
            }
        } else if (cancelReceptionLimitTime !== null) {
            const limitTime: string[] = cancelReceptionLimitTime.split(':')
            const minute: number = (Number(limitTime[0]) * 60) + Number(limitTime[1])

            const targetMoment: Moment =
                startDateTimeMoment.clone().subtract(minute, 'minutes')

            if (currentDateTime.isSameOrAfter(targetMoment, 'minute')) {
                return true
            }
        }
    }
    return false
}
